// src/middleware/guest.ts
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

export default function guest(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
  const isAuthenticated = !!localStorage.getItem('token')
  if (isAuthenticated) {
    next({ name: 'dashboard' })
  } else {
    next()
  }
}
